import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import RobotsTable from './robots-table';
import RobotsTile from './robots-tile';
import RobotsSearch from './robots-search';
import RobotsNavBar from './robots-nav-bar';

const RobotsContent = props => {
  const [activeLane, setActiveLane] = useState('ALL');
  const tileView = useSelector(state => state.robots?.tileView ?? true);

  return (
    <div className="card table-list-card">
      <div className="card-body">
        <div className="table-top w-100">
          <RobotsSearch />
        </div>
        <div className="d-flex">
          <RobotsNavBar onLaneChange={setActiveLane} activeLane={activeLane} />
          {!tileView ? <RobotsTable activeLane={activeLane} /> : <RobotsTile />}
        </div>
      </div>
    </div>
  );
};

export default RobotsContent;
